import React, { useEffect } from 'react';
import { useMouseWheel } from '../../shared/hooks/useMouseWheel';

interface MouseWheelContainerProps {
  children: React.ReactNode;
  step?: number;
  onDelta?: (delta: number) => void;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Container that captures wheel events and passes delta to callback
 */
export const MouseWheelContainer: React.FC<MouseWheelContainerProps> = ({
  children,
  step = 5,
  onDelta,
  className,
  style,
}) => {
  const { containerRef } = useMouseWheel({ step, enabled: true });

  useEffect(() => {
    const target = containerRef.current;
    if (!target || !onDelta) return;

    const listener = (e: Event) => {
      const ce = e as CustomEvent<number>;
      onDelta(ce.detail);
    };

    target.addEventListener('mousewheel-delta', listener);
    return () => target.removeEventListener('mousewheel-delta', listener);
  }, [containerRef, onDelta]);

  return (
    <div ref={containerRef} className={className} style={style}>
      {children}
    </div>
  );
};
